var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDownward48Line = function SvgIconArrowDownward48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.73 23.82-8.07 8.47V10h-3.35v22.29l-8.07-8.47-2.46 2.34L21.91 36.8a2.901 2.901 0 0 0 4.2 0l10.13-10.64-2.51-2.34Z",
    fill: "current"
  })));
};
export default SvgIconArrowDownward48Line;